export default __webpack_public_path__ + "static/assets/med_x_powder_2.6d40ed55.png";